import styled from "styled-components";

export const VideoSlidesFilterItemPreviewFooterDefaultBox = styled.div`
    display: flex;
    position: absolute;
    height: 8rem;
    bottom: 0;
    align-items: end;
    justify-content: center;
    width: 100%;
    padding: 1rem 0rem;
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))
`;